var exports = {
  "X": "mutedText__Min8MB",
  "Y": "feedbackBubble___mn8x_",
};

module.exports = exports;
